// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  workspaceId: __t.option(__t.u64()),
  executorLane: __t.string(),
  harnessVersion: __t.string(),
  taskTag: __t.string(),
  evidenceCompleteness: __t.f32(),
  setupFriction: __t.f32(),
  costVisibility: __t.f32(),
  commandControl: __t.f32(),
  artefactCapture: __t.f32(),
  avgLatencyMs: __t.u32(),
  failureRecovery: __t.f32(),
  sampleCount: __t.u32(),
};
